// extracted by mini-css-extract-plugin
export default {"wrapperPage":"Settings_wrapperPage__GBDdk","wrapperHeader":"Settings_wrapperHeader__SfsvK","title":"Settings_title__efEvB","wrapperContent":"Settings_wrapperContent__sLank"};